import __request__ from "routing/request";
export function generateClusterDebugEvent(text) {
  return __request__("POST", "/system/debug/events/cluster", text, {}, {
    "Accept": ["application/json"]
  });
}
export function showLastClusterDebugEvent() {
  return __request__("GET", "/system/debug/events/cluster", null, {}, {
    "Accept": ["application/json"]
  });
}
export function generateDebugEvent(text) {
  return __request__("POST", "/system/debug/events/local", text, {}, {
    "Accept": ["application/json"]
  });
}
export function showLastDebugEvent() {
  return __request__("GET", "/system/debug/events/local", null, {}, {
    "Accept": ["application/json"]
  });
}
